module.exports = __webpack_public_path__ + "2736432b7be59c072a96a1bc5bd3b7b1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SE-SKA.svg
// module id = tpkO
// module chunks = 0